module.exports = __webpack_public_path__ + "img/img-6.7821ebc7.png";